import { useState } from 'react'

import { styled } from 'styled-components'

import { Banner, Button, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints } from '@b-stock/fe-core/design-system'

import useIsLoggedIn from '@/buyer-portal/helpers/useIsLoggedIn'
import { redirectSignUp, redirectToAuth } from '@/helpers/auth'

const BannerActions = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
`

const BannerWrapper = styled.div`
  @media ${Breakpoints.max.medium} {
    margin-bottom: 1rem;
  }
`

export const UnauthorizedBanner = ({
  trackButtonClick,
}: {
  trackButtonClick: (buttonName: string) => void
}) => {
  const handleSignIn = () => {
    redirectToAuth()
    trackButtonClick('sign_in')
  }

  const handleRegister = () => {
    redirectSignUp()
    trackButtonClick('register')
  }

  const [showUnauthorizedBanner, setShowUnauthorizedBanner] = useState(true)
  const isLoggedIn = useIsLoggedIn()

  return !isLoggedIn && showUnauthorizedBanner ? (
    <BannerWrapper>
      <Banner
        narrow
        onDismiss={() => {
          setShowUnauthorizedBanner(false)
        }}
      >
        <div data-testid="unauthorized-banner-message">
          <FormattedMessage id="Auction.shipment.unAuthBanner.description" />
        </div>
        <BannerActions>
          <Button
            type="button"
            onClick={handleSignIn}
            size="small"
            appearance="secondary"
          >
            <FormattedMessage id="Common.signIn" />
          </Button>

          <Button
            type="button"
            onClick={handleRegister}
            size="small"
            appearance="tertiary"
          >
            <FormattedMessage id="Common.register" />
          </Button>
        </BannerActions>
      </Banner>
    </BannerWrapper>
  ) : null
}
